import React from 'react';
import { DateFieldSC } from './date-field.styled';
import { useIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useFieldData } from '../../reservation-form.utils';
import { DateTimePicker } from '../../../../../../components/ui';
import { getShortDateFormat } from '../../../../../../helpers/utils-helpers';
import moment from 'moment';
import CalendarIcon from '../../../../../../assets/svg/e-calendar/calendar-icon.svg';
import { actions } from '../../../../../../store/ducks/reservation-form-slice';
import { SelectFieldProps } from '../../../../../../types/reservation-form';
import { FormField } from '@hilbi/web-common/components/hilbi-form';

type DateFieldProps = SelectFieldProps & ReturnType<typeof mapDispatchToProps>;

const DateField: React.FunctionComponent<DateFieldProps> = ({
  name,
  changeReservationFormDate,
}) => {
  const { formatMessage } = useIntl();
  const { value, setValue, error } = useFieldData(name);
  return (
    <DateFieldSC>
      <FormField error={error ? formatMessage({ id: error }) : ''} icon={CalendarIcon}>
        <DateTimePicker
          generateConfig="moment"
          kind="inline"
          format={getShortDateFormat()}
          picker="date"
          value={moment(value)}
          onChange={(momentDate) => {
            if (momentDate) {
              const isoDate = momentDate.toDate().toISOString();
              changeReservationFormDate(isoDate);
              setValue(isoDate);
            }
          }}
        />
      </FormField>
    </DateFieldSC>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      changeReservationFormDate: actions.changeReservationFormDate,
    },
    dispatch,
  );
};

export default connect(null, mapDispatchToProps)(React.memo(DateField));
